import * as React from "react";
import { CheckboxWithLabel, CheckboxWithLabelProps } from "formik-mui";
import { Field, useFormikContext } from "formik";
import { FormHelperText } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";

interface Props extends Omit<CheckboxWithLabelProps, "field" | "form" | "meta"> {
  name: string;
  helperText?: string;
  requiredMessage?: string;
}

const CheckboxField: React.FC<Props> = ({ name, helperText, required, requiredMessage, ...props }) => {
  const { errors, touched } = useFormikContext<Record<string, boolean>>();
  const helperId = `${name}-helper-text`;
  const { t } = useTranslation();
  const requiredErrorMessage = requiredMessage || t("common.validation.required");

  const validate = React.useCallback(
    (value: string | undefined) => {
      if (required && !value) {
        return requiredErrorMessage;
      }
      return undefined;
    },
    [required, requiredErrorMessage]
  );

  return (
    <Stack flexGrow={0}>
      <Field
        name={name}
        type="checkbox"
        component={CheckboxWithLabel}
        validate={validate}
        inputProps={{ "aria-describedby": helperId }}
        {...props}
      />
      <FormHelperText id={helperId} margin="dense" required={required} error={touched[name] && !!errors[name]}>
        {(touched[name] && errors[name]) || helperText}
      </FormHelperText>
    </Stack>
  );
};

export { CheckboxField };
